<script>
export default{
    methods: {
    formatCurrency(amount, currency = 'SYP') {
      const numAmount = Number(amount);
      
      // Define currency symbols
      const currencySymbols = {
        USD: "$",
        SYP: "ل.س",
        EUR: "€",
        GBP: "£",
        SAR: "ر.س",
        AED: "د.إ",
        JOD: "د.أ",
        EGP: "ج.م",
      };
      
      const symbol = currencySymbols[currency] || currency;
      
      // Only add thousand separator if number is 1000 or greater
      if (numAmount >= 1000) {
        const formatted = new Intl.NumberFormat("ar-sy", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(numAmount);
        return `${formatted} ${symbol}`;
      } else {
        // For numbers less than 1000, just show the number without separators
        return `${numAmount} ${symbol}`;
      }
    },
}
}
</script>